import * as React from "react";
import { isPage } from "@bloomreach/spa-sdk";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { fetchPagedComponent } from "../helpers/hooks/helpers/helpers.js";
import { useBrConfigurationContext } from "../../context/context/configuration.js";
import { getContentByRef } from "../../utils/utils/get-content-by-ref.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
function parseBloomreachArticles(pageable, highlighted, page, refPrefix) {
  const { currentPage, nextPage, totalPages, items = [] } = pageable ?? {};
  let articles = [];
  let highlightedContent = void 0;
  if (isPage(page)) {
    highlightedContent = getBrPageContent(page, highlighted);
    articles = items.map((item) => getBrPageContent(page, item)).filter(Boolean);
  } else {
    highlightedContent = getContentByRef(highlighted.$ref, page, refPrefix)?.data;
    articles = items.map((item) => item && getContentByRef(item.$ref, page, refPrefix)?.data).filter(Boolean);
  }
  return {
    highlighted: highlightedContent,
    paged: {
      items: articles,
      currentPage,
      nextPage,
      totalPages
    }
  };
}
const useBloomreachArticles = ({ component, page }) => {
  const { apiUrl } = useBrConfigurationContext();
  const { locale } = useIntl();
  const {
    isMultilingualEnabled,
    featureConfigs: { bloomreachRefPrefix }
  } = useFeatureToggles();
  const componentId = component.getId();
  const localeTransformed = locale.replace("-", "_");
  const url = isMultilingualEnabled ? `${apiUrl}/${localeTransformed}` : apiUrl;
  const { pageable, highlightedArticle } = component.getModels();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const [result, setResult] = React.useState(() => {
    return parseBloomreachArticles(pageable, highlightedArticle, page, bloomreachRefPrefix);
  });
  const [currentPage, setCurrentPage] = React.useState(result.paged.currentPage ?? 1);
  const loadNextPage = React.useCallback(() => {
    result.paged.nextPage && setCurrentPage(result.paged.nextPage);
  }, [result.paged.nextPage]);
  React.useEffect(() => {
    if (currentPage === result.paged.currentPage) {
      return;
    }
    const path = isMultilingualEnabled ? window?.location.pathname.replace(`/${localeTransformed}`, "") : window?.location.pathname;
    let current = true;
    setLoading(true);
    fetchPagedComponent(url, componentId, currentPage, path).then((result2) => {
      if (current) {
        const fetchedPage = getContentByRef(result2.root.$ref, result2, bloomreachRefPrefix);
        if (fetchedPage.models) {
          const { pageable: pageable2, highlightedArticle: highlightedArticle2 } = fetchedPage.models;
          const { paged } = parseBloomreachArticles(
            pageable2,
            highlightedArticle2,
            result2,
            bloomreachRefPrefix
          );
          setResult((state) => ({
            ...state,
            paged: {
              ...paged,
              items: [...state.paged.items, ...paged.items]
            }
          }));
        }
        setLoading(false);
      }
    }).catch((err) => {
      if (current) {
        console.error(err);
        setError(err);
        setLoading(false);
      }
    });
    return () => {
      current = false;
    };
  }, [
    url,
    currentPage,
    result.paged.currentPage,
    page,
    componentId,
    isMultilingualEnabled,
    localeTransformed,
    bloomreachRefPrefix
  ]);
  return { loading, error, result, loadNextPage };
};
export {
  useBloomreachArticles
};
//# sourceMappingURL=use-bloomreach-articles.js.map
